"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const modalContext_1 = require("./modalContext");
const modalAnimation_1 = require("./modalAnimation");
const utils_1 = require("./utils");
const Portal_1 = require("./Portal");
const Modal = ({ children, id, consumer, isOpen, setOpen, allowClickOutside = true, duration = 0, overlayColor = 'rgba(0, 0, 0, 0.6)', animation = { type: '', base: '', before: '', after: '' }, vertical = 0, horizontal = 0, width = 0, height = 0, radius = 0, backgroundColor = 'transparent', asyncOpen, spinner, spinnerColor = 'rgba(45, 52, 54, 0.6)', draggable = false, }) => {
    duration = (animation === null || animation === void 0 ? void 0 : animation.type) && !duration ? 150 : duration;
    if (draggable && animation.type.match(/top|bottom|left|right/))
        animation = modalAnimation_1.modalAnimation.scaleUp;
    (0, react_1.useEffect)(() => {
        (0, utils_1.checkRequiredProps)({ id, consumer, isOpen, setOpen });
        (0, utils_1.checkCustomStyle)({ id, width, height, backgroundColor });
    }, []);
    const hashId = (0, utils_1.hash)(id);
    const Context = (0, react_1.useMemo)(() => (0, modalContext_1.createModalContext)(id), []);
    const ContextProps = (0, react_1.useMemo)(() => (0, modalContext_1.createModalContextProps)(id), []);
    const [initialization, setInitialization] = (0, react_1.useState)(false);
    const [pending, setPending] = (0, react_1.useState)(false);
    const [customProps, setCustomProps] = (0, react_1.useState)({});
    const setCustomPropsWithCheckPropsCondition = (0, react_1.useCallback)((props) => {
        if ((0, utils_1.checkPropsCondition)(props))
            return setCustomProps(props);
        setCustomProps({});
    }, [customProps]);
    const open = (0, react_1.useCallback)((props) => __awaiter(void 0, void 0, void 0, function* () {
        setOpen(true);
        setCustomPropsWithCheckPropsCondition(props);
        if (!initialization)
            setInitialization(true);
        if (!asyncOpen)
            return;
        setPending(true);
        yield asyncOpen();
        setPending(false);
    }), [customProps]);
    const close = (0, react_1.useCallback)(() => setOpen(false), []);
    const keyUpHandler = (0, react_1.useCallback)(({ key }) => {
        if (key !== 'Escape')
            return;
        if ([...modalSet][modalSet.size - 1] !== id)
            return;
        close();
    }, []);
    (0, react_1.useEffect)(() => {
        if (!isOpen)
            return window.removeEventListener('keyup', keyUpHandler);
        window.addEventListener('keyup', keyUpHandler);
        modalSet.add(id);
    }, [isOpen]);
    const providerValues = (0, react_1.useMemo)(() => ({
        open,
        close,
    }), []);
    const propsProviderValues = (0, react_1.useMemo)(() => (Object.assign({}, customProps)), [customProps]);
    return ((0, jsx_runtime_1.jsx)(ContextProps.Provider, Object.assign({ value: propsProviderValues }, { children: (0, jsx_runtime_1.jsxs)(Context.Provider, Object.assign({ value: providerValues }, { children: [consumer, (0, jsx_runtime_1.jsx)(Portal_1.default, Object.assign({ id: id, hashId: hashId, modalSet: modalSet, initialization: initialization, pending: pending, isOpen: isOpen, close: close, allowClickOutside: allowClickOutside, spinner: spinner, spinnerColor: spinnerColor, duration: duration, modalStyle: (0, utils_1.getModalStyle)({
                        hashId,
                        duration,
                        overlayColor,
                        vertical,
                        horizontal,
                        animation,
                        width,
                        height,
                        radius,
                        backgroundColor,
                    }), draggable: draggable }, { children: children }))] })) })));
};
const modalSet = new Set();
exports.default = Modal;
